import { useTranslation } from 'react-i18next';

export default function AuroraOverviewSection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('aurora.overview.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('aurora.overview.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-gray-900 rounded-xl p-8 border border-gray-700">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-wallet-3-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-white ml-4">{t('aurora.overview.feature1.title')}</h3>
            </div>
            <p className="text-gray-300 leading-relaxed">
              {t('aurora.overview.feature1.desc')}
            </p>
          </div>

          <div className="bg-gray-900 rounded-xl p-8 border border-gray-700">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                <i className="ri-global-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-white ml-4">{t('aurora.overview.feature2.title')}</h3>
            </div>
            <p className="text-gray-300 leading-relaxed">
              {t('aurora.overview.feature2.desc')}
            </p>
          </div>

          <div className="bg-gray-900 rounded-xl p-8 border border-gray-700">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                <i className="ri-exchange-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-white ml-4">{t('aurora.overview.feature3.title')}</h3>
            </div>
            <p className="text-gray-300 leading-relaxed">
              {t('aurora.overview.feature3.desc')}
            </p>
          </div>

          <div className="bg-gray-900 rounded-xl p-8 border border-gray-700">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-yellow-600 rounded-lg flex items-center justify-center">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-white ml-4">{t('aurora.overview.feature4.title')}</h3>
            </div>
            <p className="text-gray-300 leading-relaxed">
              {t('aurora.overview.feature4.desc')}
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-purple-900 to-blue-900 rounded-xl p-8 border border-purple-700">
          <h3 className="text-2xl font-bold text-white mb-4 flex items-center">
            <i className="ri-lightbulb-flash-line text-3xl text-yellow-400 mr-3"></i>
            {t('aurora.overview.recommended.title')}
          </h3>
          <ul className="grid md:grid-cols-3 gap-4">
            <li className="flex items-start">
              <i className="ri-check-line text-green-400 text-xl mr-2 mt-1"></i>
              <span className="text-gray-200">{t('aurora.overview.recommended.item1')}</span>
            </li>
            <li className="flex items-start">
              <i className="ri-check-line text-green-400 text-xl mr-2 mt-1"></i>
              <span className="text-gray-200">{t('aurora.overview.recommended.item2')}</span>
            </li>
            <li className="flex items-start">
              <i className="ri-check-line text-green-400 text-xl mr-2 mt-1"></i>
              <span className="text-gray-200">{t('aurora.overview.recommended.item3')}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}